import React, { PureComponent } from 'react'
import { Row, Col } from 'pui-react-grids'
import InfoSideMenu from '../common/InfoSideMenu'
import InfoTopMenu from '../common/InfoTopMenu'
import Footer from '../common/Footer'
import PercheSwapick from '../common/Infotext/PercheSwapick'
import ComeFare from '../common/Infotext/ComeFare'
import GuidaSicurezza from '../common/Infotext/GuidaSicurezza'
import SpedizioneOggetti from '../common/Infotext/SpedizioneOggetti'
import Faq from '../common/Infotext/Faq'
import ServiziAggiuntivi from '../common/Infotext/ServiziAggiuntivi'
import Termini from '../common/Infotext/Termini'
import PrivacyPolicy from '../common/Infotext/PrivacyPolicy'
import CookiePolicy from '../common/Infotext/CookiePolicy'

class ComeFunziona extends PureComponent {
  componentDidMount() {
    const hash = this.props.history.location.hash
    this.timeoutId = setTimeout(() => {
      let element
      if (hash) {
        element = document.getElementById(hash.substr(1))
      }
      if (element) {
        element.scrollIntoView({ block: 'start' })
      } else {
        window.scrollTo(0, 0)
      }
    }, 100) /* Magic number to prevent browser auto restore scroll */
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId)
  }

  render() {
    return (
      <div>
        <div className="hidden-md hidden-lg">
          <InfoTopMenu />
        </div>
        <Row style={{ marginLeft: 0, marginRight: 0, maxWidth: '100%' }}>
          <div className="padding-no-for-small">

            <Col md={6} sm={24} xs={24}>
              <div className="InfoSideMenuContainer hidden-sm hidden-xs">
                <InfoSideMenu />
              </div>
            </Col>

            <Col md={18} sm={24} xs={24}>

              <section id="perche-swapick">
                <PercheSwapick />
              </section>

              <section id="come-fare">
                <ComeFare />
              </section>

              <section id="guida-sicurezza">
                <GuidaSicurezza />
              </section>

              <section id="spedizione-oggetti">
                <SpedizioneOggetti />
              </section>

              <section id="faq">
                <Faq />
              </section>

              <section id="servizi-aggiuntivi">
                <ServiziAggiuntivi />
              </section>

              <section id="termini-condizioni">
                <Termini />
              </section>

              <section id="privacy-policy">
                <PrivacyPolicy />
              </section>

              <section id="cookie-policy">
                <CookiePolicy />
              </section>

            </Col>
          </div>
        </Row>
        <Footer />
      </div>
    )
  }
}

export default ComeFunziona



// WEBPACK FOOTER //
// ./src/pages/ComeFunziona.js